export default __webpack_public_path__ + "static/media/sun-blue.f58074a5.png";